export default "__VITE_ASSET__a25b8c54__"